import { useSettings } from "@/context/SettingsContext";
import { IMG } from "@/data/images";
import { imgSrc } from "@/lib/img";

// Returns a resolver that prefers an admin-uploaded override for a given IMG key,
// falling back to the bundled default image.
export const useImg = () => {
  const s = useSettings();
  return (key) => {
    const override = s?.images?.[key];
    return override ? imgSrc(override) : IMG[key];
  };
};
